import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlloxCommonAsyncPipe, IAlloxAsyncPipeFetch, IAlloxAsyncPipeOption } from './allox-common-async.pipe';
import { DeviceModelGroup, DeviceModelGroupService } from '@app/core';

interface IDeviceModelGroupPipeOption extends IAlloxAsyncPipeOption {
  name?: boolean;
}
@Pipe({
    name: 'deviceModelGroup', pure: false,
    standalone: false
})
export class DeviceModelGroupPipe
  extends AlloxCommonAsyncPipe<DeviceModelGroup>
  implements IAlloxAsyncPipeFetch<DeviceModelGroup>, PipeTransform {

  constructor(private service: DeviceModelGroupService, changeDetectorRef: ChangeDetectorRef, router: Router) {
    super(changeDetectorRef, router);
  }

  fetchDependency(value: number) {
    return this.service.fetch(value);
  }

  makeText(value: number, obj: DeviceModelGroup, option?: IDeviceModelGroupPipeOption) {
    if (!obj) {
      return `Unknown [id: ${value}]`;
    }
    return obj.name;
  }

}
